export enum TaxonomyMarketAbbreviaton {
  AG = 'AG',
  FH = 'FH',
  HCIC = 'HCIC',
  PC = 'PC',
  PH = 'PH',
}

export type CountryConfig = {
  /** e.g. UK, DE, BNL */
  eLabCountrySlug: CountrySlug;
  /** e.g. GB, IN */
  crmTwoAlphaCountryAbbreviation: string;
  /** e.g. GBR, IND */
  datalakeCountryAbbreviation: string;
  /** e.g. ['Belgium', 'Netherlands', 'Luxembourg'] */
  countries?: Countries;
};

export type CountryConfigs = Record<string, CountryConfig>;

export type MarketConfig = {
  /** e.g. PersonalCare */
  eLabMarketSlug: MarketSlug;
  /** e.g. TaxonomyMarketAbbreviaton.PC, TaxonomyMarketAbbreviaton.FH */
  taxonomyMarketAbbreviaton: TaxonomyMarketAbbreviaton;
  /** e.g. Personal Care */
  crmMarketSegment: CRMMarket;
};

export type MarketConfigs = Record<Market, MarketConfig>;

export type CountryMarketSpecificConfig = {
  /** e.g. United Kingdom */
  countryCluster: CountryCluster;
  /** e.g. Personal Care */
  marketDisplayName: Market;
  /** e.g. uk_pc */
  customerPortalMarketSegmentId: string;
  /** e.g. £, €, $ */
  currency: string;
  /** e.g. kg */
  weightUnit: string;
  /** e.g. 'Azelis UK Limited\nFoxholes Business Park\nJohn Tate Road\nHertford\nHertfordshire\nSG13 7YH' */
  labAddress: string;
  languages: Languages;
  emails: EmailsByEnvironment;
};

export type CountryMarketConfig = CountryConfig &
  MarketConfig &
  CountryMarketSpecificConfig;

export type CountryCluster = string;
export type Country = string;
export type Countries = [Country, ...Country[]];

export type CountrySlug = string;

// Internallly used Market Display Name
export enum Market {
  AgriEnvironmental = 'Agricultural & Environmental Solutions',
  SpecialtyAgriHorti = 'Special Agricultural & Environmental Solutions',
  FoodNutrition = 'Food & Nutrition',
  FoodHealth = 'Food & Health',
  HomecareIndustrialCleaning = 'Home Care & Industrial Cleaning',
  HomeCareIndustrialCleaning = 'Home Care & Industrial Cleaning',
  PersonalCare = 'Personal Care',
}

// These need to match the names from https://org179786ef.crm4.dynamics.com/api/data/v9.2/aze_ibas?$select=aze_name
export enum CRMMarket {
  AgriEnvironmental = 'Agricultural & Environmental Solutions',
  FoodNutrition = 'Food & Nutrition',
  HomeCareIndustrialCleaning = 'Homecare & Industrial Cleaning',
  PersonalCare = 'Personal Care',
}

export enum MarketSlug {
  AgriEnvironmental = 'AgriculturalEnvironmentalSolutions',
  FoodNutrition = 'FoodNutrition',
  HomeCareIndustrialCleaning = 'HomeCareIndustrialCleaning',
  PersonalCare = 'PersonalCare',
}

export enum Language {
  deDE = 'de_DE',
  enGB = 'en_GB',
  enUS = 'en_US',
  frFR = 'fr_FR',
  zhCN = 'zh_CN',
  koKR = 'ko_KR',
}

export enum LanguageNames {
  de_DE = 'German',
  en_GB = 'English (Great Britain)',
  en_US = 'English (American)',
  fr_FR = 'French',
  zh_CN = 'Chinese',
  ko_KR = 'Korean',
}

export type Languages = [Language, ...Language[]];

export type EmailsByEnvironment = {
  development: string;
  staging: string;
  production: string;
};

export type CountryMarketConfigList = Record<
  CountryCluster,
  { [key: string]: CountryMarketConfig }
>;

export type CountryMarketConfigs = { [key: string]: CountryMarketConfig };
